export default __webpack_public_path__ + "navigation-examples-predictive-caching-1200-cbc9fd4453c623f6f62bc8635dd2e152.png";